import baustein from "baustein";
import requester from "web/script/modules/requester";
import overlayMixin from "web/script/components/mixins/overlay-mixin";

export default baustein.register("saved-search-edit-overlay", {
    mixins: [overlayMixin],

    defaultOptions: {
        // overlay-mixin options
        overlaySize: "medium",
        noContentPadding: false,
        queryParams: {},
        path: "/create-new-search/",

        savedLystFilterId: null,
    },

    onOverlayCloseIntent() {
        this.close();
    },

    getOverlayContent() {
        this.options.queryParams["edit"] = this.options.savedLystFilterId;
        this.options.queryParams["overlay"] = 1;
        return requester(this.options.path, {
            headers: {
                Accept: "text/html",
            },
            query: this.options.queryParams,
        }).then((resp) => {
            return requester.toText(resp);
        });
    },
});
